import React from 'react';
import { motion } from 'framer-motion';
import { FaEnvelope } from 'react-icons/fa';
import './FacultyBoard.css';
import { useTranslation } from 'react-i18next';

const FacultyBoard = () => {
    const { t } = useTranslation();

    const boardMembers = [
        {
            name: "Prof. Dr. Hatice Mergen",
            email: "mergen@hacettepe.edu.tr",
            title: t('dean.title'),
            photo: "https://avesis.hacettepe.edu.tr/user/image/5582",
            isPresident: true
        },
        {
            name: "Doç. Dr. Uğur Karabey",
            email: "ukarabey@hacettepe.edu.tr",
            title: t('faculty_board.head_of_actuarial_science'),
            photo: "https://avesis.hacettepe.edu.tr/user/image/5811"
        },
        {
            name: "Prof. Dr. Işık Perçin Demirçelik",
            email: "ipercin@hacettepe.edu.tr",
            title: t('faculty_board.head_of_biology'),
            photo: "https://avesis.hacettepe.edu.tr/user/image/6813"
        },
        {
            name: "Prof. Dr. Serpil Aktaş Altunay",
            email: "spxl@hacettepe.edu.tr",
            title: t('faculty_board.head_of_statistics'),
            photo: "https://avesis.hacettepe.edu.tr/user/image/5439"
        },
        {
            name: "Prof. Dr. Ahmet Nedim Ay",
            email: "ay@hacettepe.edu.tr",
            title: t('faculty_board.head_of_chemistry'),
            photo: "https://avesis.hacettepe.edu.tr/user/image/7556"
        },
        {
            name: "Prof. Dr. İsmet Yurduşen",
            email: "yurdusen@hacettepe.edu.tr",
            title: t('faculty_board.head_of_mathematics'),
            photo: "https://avesis.hacettepe.edu.tr/user/image/7241"
        },
        {
            name: "Prof. Dr. Hatice Kaplan Can",
            email: "hkaplan@hacettepe.edu.tr",
            title: t('faculty_board.professor_member'),
            photo: "https://avesis.hacettepe.edu.tr/user/image/6466"
        },
        {
            name: "Prof. Dr. Nuray Akbulut",
            email: "emir@hacettepe.edu.tr",
            title: t('faculty_board.professor_member'),
            photo: "https://avesis.hacettepe.edu.tr/user/image/6611"
        },
        {
            name: "Prof. Dr. Barış Temelli",
            email: "temelli@hacettepe.edu.tr",
            title: t('faculty_board.professor_member'),
            photo: "https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/resimler/BARIS%20TEMELLI2.png"
        },
        {
            name: "Doç.Dr. Özge Karadağ Ataş",
            email: "ozgekaradag@hacettepe.edu.tr",
            title: t('faculty_board.associate_professor_member'),
            photo: "https://avesis.hacettepe.edu.tr/user/image/6271"
        },
        {
            name: "Doç. Dr. İsmail Aslan",
            email: "ismail-aslan@hacettepe.edu.tr",
            title: t('faculty_board.associate_professor_member'),
            photo: "https://avesis.hacettepe.edu.tr/user/image/12320"
        },
        {
            name: "Dr. Öğr. Üyesi Handan Sevim Akan",
            email: "sevimh@hacettepe.edu.tr",
            title: t('faculty_board.assistant_professor_member'),
            photo: "https://avesis.hacettepe.edu.tr/user/image/5524"
        },
        {
            name: "Gülnihal Doğruyol Aslan",
            email: "nihala@hacettepe.edu.tr",
            title: t('faculty_board.faculty_secretary_rapporteur'),
            photo: "https://avesis.hacettepe.edu.tr/Content/images/user2.png"
        },
        {
            name: "Öğr.Gör. Dr. Güzin Emecen",
            email: "guzin@hacettepe.edu.tr",
            title: t('faculty_board.lecturer_representative'),
            photo: "https://avesis.hacettepe.edu.tr/user/image/6001"
        },
        {
            name: "Arş.Gör. Yavuz Alagöz",
            email: "yavuzalagoz@hacettepe.edu.tr",
            title: t('faculty_board.research_assistant_representative'),
            photo: "https://avesis.hacettepe.edu.tr/user/image/100871"
        }
    ];

    return (
        <div className="font-sans bg-[#f0f4ff]">
            {/* Full-screen Video Hero */}
            <div className="h-[120vh] w-full relative overflow-hidden -mt-40">
                <video
                    className="absolute top-1/2 left-1/2 w-full h-full object-cover transform -translate-x-1/2 -translate-y-1/2"
                    src="/fenfakultesivideo.mp4"
                    autoPlay
                    loop
                    muted
                    playsInline
                />
                <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-black/80"></div>
                <div className="relative z-10 h-full flex flex-col items-center justify-center text-center pt-40">
                    <motion.h1 
                        className="text-5xl md:text-8xl font-black text-white uppercase" 
                        style={{ textShadow: '0px 5px 20px rgba(0,0,0,0.5)' }}
                        initial={{ opacity: 0, y: -50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                    >
                        {t('faculty_board.title')}
                    </motion.h1>
                    <motion.p 
                        className="mt-4 text-lg md:text-xl text-white/90 font-medium max-w-2xl" 
                        style={{ textShadow: '0px 2px 10px rgba(0,0,0,0.5)' }}
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
                    >
                        {t('faculty_board.subtitle')}
                    </motion.p>
                </div>
                {/* Scroll Indicator */}
                <motion.div 
                    className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10"
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ 
                        duration: 1,
                        delay: 0.5,
                        repeat: Infinity,
                        repeatType: "reverse"
                    }}
                >
                    <div className="text-white text-center">
                        <div className="w-6 h-10 border-2 border-white rounded-full mx-auto mb-2 relative">
                            <div className="w-1 h-2 bg-white rounded-full absolute left-1/2 top-2 transform -translate-x-1/2"></div>
                        </div>
                        <span className="text-sm font-light">{t('common.scrollDown')}</span>
                    </div>
                </motion.div>
            </div>

            {/* Faculty Board Members Section */}
            <section className="py-20 relative z-20 bg-gradient-to-b from-[#f0f4ff] to-white">
                <div className="container mx-auto px-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {boardMembers.map((member, index) => (
                            <motion.div
                                key={member.email}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.5, delay: index * 0.1 }}
                                className="bg-white/40 backdrop-blur-xl border-white/20 rounded-3xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300"
                            >
                                <div className="p-6">
                                    <div className="flex items-center space-x-4">
                                        <div className="flex-shrink-0">
                                            <div className="faculty-member-photo">
                                                <img
                                                    src={member.photo}
                                                    alt={member.name}
                                                    className="w-20 h-20 object-cover"
                                                    onError={(e) => {
                                                        e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(member.name)}&background=8B1538&color=fff`;
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="flex-1 min-w-0">
                                            <h2 className="text-lg font-semibold text-gray-900 truncate faculty-member-name">
                                                {member.name}
                                            </h2>
                                            <p className="text-sm text-gray-600 mb-2 faculty-member-title">
                                                {member.title}
                                            </p>
                                            <a
                                                href={`mailto:${member.email}`}
                                                className="inline-flex items-center text-sm text-blue-600 hover:text-blue-800 faculty-member-email"
                                            >
                                                <FaEnvelope className="mr-2" />
                                                {member.email}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default FacultyBoard; 